/**
 * Inline Creation Schema — Category
 *
 * Used by relation resolution when an activity references a category name
 * that does not exist yet.
 */

import { UploadSchema } from '../types';

export const v2CategorySchema: UploadSchema = {
	entityType: 'v2Category',
	label: 'Category',
	apiEndpoint: '/v1/categories',
	apiMethod: 'POST',
	payloadTransform: (formValues, projectId) => ({
		name: formValues.name,
		project: projectId,
	}),
	fields: [
		{
			name: 'name',
			label: 'Category Name',
			dataType: 'string',
			required: true,
			headerAliases: ['Category', 'Activity Category'],
		},
	],
};
